import module from 'contabilidad/polizasexternas/module'

export class PolizasExternasPermisosService {
  constructor($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get('/api/contabilidad/polizasexternas/permisos')
  }
}

module.service('PolizasExternasPermisosService', PolizasExternasPermisosService)


// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/services/PolizasExternasPermisos.js